<template>
    <div id="filters" class="filters-container" :class="isSticking ? 'sticky' : ''">
        <div class="filters-internal">
            <div class="filter-header" @click="expandFilters"><img src="https://happyboxstore.com/cdn/shop/files/Group_1790.png?v=1720194132"/> <p>Filters <span v-if="totalCurrentFilters > 0">({{totalCurrentFilters}})</span></p>  <img :class="isExpanded ? 'flipped' : ''" src="https://happyboxstore.com/cdn/shop/files/Group_3438.png?v=1720194132"/></div>
            <div v-if="isExpanded">
                <CategoriesFilter @goall="goAll" :categoriesArray="categoryFilters"/>
                <OccasionFilter :occasions="occasionsFilters"/>
                <PriceFilter @goall="goAll" v-if="maxMinPrices" :prices="maxMinPrices"/>
                <GenericFilter @goall="goAll" :filteredAddons="filteredAddons" :filters="filters" v-for="filters in mappedFilters" :key="filters.category"/>
                <div v-if="totalCurrentFilters > 0" class="reset-button">
                    <button @click="resetFilters" class="happybox-button white border">RESET</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import OccasionFilter from './Filters/OccasionFilter.vue';
import CategoriesFilter from './Filters/CategoriesFilter.vue';
import PriceFilter from './Filters/PriceFilter.vue';
import GenericFilter from './Filters/GenericFilter.vue';
export default {
    components: {
        OccasionFilter,
        CategoriesFilter,
        PriceFilter,
        GenericFilter,
    },
    data() {
        return{
            isExpanded: false,
        }
    },
    props:{
        filteredAddons: Array,
        filteredPreAddons: Array,
        isSticking: Boolean,
        allItems: Boolean,
    },
    computed: {
        ...mapGetters([
            'addonProducts',
            'selectedFilters',
            'occasions',
            'categories',
            'selectedCategories',
            'selectedOccasion'
        ]),
        selectedSort: {
            get(){ return this.$store.state.selectedSort},
            set(value){
                this.$store.commit('setSelectedSort', value );
                const pageContainer = document.getElementById('PageContainer');
                if (pageContainer) pageContainer.scrollTop = 0;
            }
        },
        mappedFilters(){
            var tags = [...new Set(this.addonProducts.flatMap(x => x.tags.filter(y => y.includes("Filter_") && !y.includes("Occasion") && !y.includes("Vibe"))))];
            if(tags.length > 0){
                tags = tags.map((x) =>{
                    const currentArray = x.replace("Filter_","").split("_");
                    if (currentArray.length > 1){
                        var currentObject = { category: currentArray[0], value: currentArray[1], tag: x };
                        return currentObject;
                    }
                })
                var sortedFilters = [];
                sortedFilters = [...tags.reduce((hash, {category,value,tag}) => {
                    const current = hash.get(category) || { category, filters: [] };
                    current.filters.push({ value, tag });
                    return hash.set(category, current);
                }, new Map).values()];
                
                return sortedFilters.filter(x => !x.category.includes("Occasions") && !x.category.includes("Category") && !x.category.includes("Arrival") && !x.category.includes("Badges") && !x.category.includes("Ethos"));
            }

            return [];
        },
        categoryFilters(){
            return this.categories;
        },
        occasionsFilters(){
            return this.occasions;
        },
        maxMinPrices(){
            var prices = this.filteredPreAddons.map(x => x.variants[0].price);
            if(prices.length > 0){
                var min = Math.floor(Math.min( ...prices )),
                max = Math.ceil(Math.max( ...prices ));

                

                return {min: min,max:max};
            }
            return null
        },
        totalCurrentFilters(){
            let total = this.selectedOccasion.length + this.selectedCategories.filter(x => x != 'View All').length + this.selectedFilters.length;
            return total
        }
    },
    methods: {
        goAll(){
            this.$emit("goall");
        },
        resetFilters(){
            this.$emit("goall");
            this.$store.commit('setAllSelectedOccasion', [] )
            this.$store.commit('setSelectedSort', 1 )
            this.$store.commit('setSelectedCategories', 'View All' )
            this.$store.commit('setRangePrice', {min:0,max:100} )
            this.$store.commit('setTotalSelectedFilters', [] )
        },
        expandFilters(){
            this.isExpanded = !this.isExpanded;
        }
    },
    mounted(){
    }
}
</script>

<style scoped>
.filters-container{
    width: 15%;
    padding: 1% 0.5rem 10%;
    overflow-y:scroll;
    overflow-x:hidden;
    position: sticky;
    top: 45px;
    left: 0;
    height: 70vw;
    transition: all 0.2s linear;
}

.filters-internal{
    width: 100%;
    padding: 2.5% 5%;
    box-shadow: 0 0 2px #0000004d;
    border-radius: 8px;
}

.filter-header{
    width: 100%;
    display: flex;
    gap: 2%;
    font-size: 1.15vw;
    align-items: center;
}

.filter-header img{
    width: 10%;
    transition: all 0.5s linear;
}

.filter-header .flipped{
    transform: rotate(180deg);
}

.filter-header p{
    width: 80%;
    font-weight: bold;
}

.reset-button{
    width: 100%;
    box-shadow: inset 0 -1px #e6e8ec;
    padding: 5% 2%;
}

.reset-button button{
    width: 100%;
    padding: 3% 0%;
}
</style>